import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/footer";
import WhatsAppCallIcons from "./components/WhatsAppCallIcons"; 

import HeroSection from "./pages/HeroSection";
import AboutSection from "./pages/AboutSection";
import HealthcareHero from "./pages/HealthcareHero";
import MedicalImageGallery from "./pages/MedicalImageGallery";
import DoctorsSection from "./pages/DoctorsSection";
import RocklandDetails from "./pages/RocklandDetails";
import PatientTestimonials from "./pages/PatientTestimonialsSection";
import AppointmentSection from "./pages/AppointmentSection";
import AboutUs from "./pages/AboutUs";
import Facilities from "./pages/Facilities";
import NeuroSection from "./pages/NeuroSection"
import BlogSection from "./pages/BlogSection";
import Contact from "./pages/Contact";
import Gallery from "./pages/Gallery";
import Video from "./pages/Video"; 
import RocklandNews from "./pages/RocklandNews";

function App() {
  return (
    <Router>
      <Navbar />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <HeroSection />
              <RocklandDetails />
              <AboutSection />
              <HealthcareHero />
              <MedicalImageGallery />
              <DoctorsSection />
              <PatientTestimonials />
            </>
          }
        />
        

        <Route path="/about" element={<AboutSection />} />
        <Route path="/healthcare" element={<HealthcareHero />} />
        <Route path="/gallerymedical-image" element={<MedicalImageGallery />} />
        <Route path="/doctors" element={<DoctorsSection />} />
        <Route path="/rockland-details" element={<RocklandDetails />} />
        <Route path="/testimonials" element={<PatientTestimonials />} />
        <Route path="/appointment" element={<AppointmentSection />} />
        <Route path="/about-us" element={<AboutUs/>}/>
        <Route path="/facilities" element={<Facilities/>}/>
        <Route path="/neuro-section" element={<NeuroSection/>}/>
        <Route path="/blog-section" element={<BlogSection/>}/>
        <Route path="/contact" element={<Contact/>}/>
        <Route path="/gallery" element={<Gallery/>}/>
        <Route path="/video" element={<Video/>}/> 
        <Route path="rockland-news"element={<RocklandNews/>}/>
        
      </Routes>

      {/* WhatsApp और Call Icons सभी pages पर */}
      <WhatsAppCallIcons />
      
     
    </Router>
  );
};

export default App;